'use client';

import { useState } from 'react';
import styles from './index.module.scss';
import Link from 'next/link';

const APP_LINKS = {
    googlePlay: 'https://play.google.com/store/apps/details?id=ae.ninjaz.mobileapp',
    appStore: 'https://apps.apple.com/eg/app/ninjaz/id6504881562',
};

export default function AnnouncementBar() {
    const [isVisible, setIsVisible] = useState(true);

    if (!isVisible) return null;

    return (
        <div className={styles.announcementBar}>
            <div className={styles.content}>
                <div className={styles.message}>
                    <svg className={styles.sparkle} viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2L13.09 8.26L19 9L13.09 9.74L12 16L10.91 9.74L5 9L10.91 8.26L12 2Z"/>
                    </svg>
                    <span className={styles.text}>
                        <span className={styles.highlight}>New!</span>
                        <span className={styles.desktopText}>Download our mobile app for seamless PRO services</span>
                        <span className={styles.mobileText}>Get our mobile app</span>
                    </span>
                </div>

                <div className={styles.buttons}>
                    <Link
                        href={APP_LINKS.appStore}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.storeLink}
                    >
                        <svg className={styles.storeIcon} viewBox="0 0 24 24" fill="currentColor">
                            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                        </svg>
                        <span>iOS</span>
                    </Link>

                    <Link
                        href={APP_LINKS.googlePlay}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.storeLink}
                    >
                        <svg className={styles.storeIcon} viewBox="0 0 24 24" fill="currentColor">
                            <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
                        </svg>
                        <span>Android</span>
                    </Link>
                </div>
            </div>

            <button
                className={styles.closeButton}
                onClick={() => setIsVisible(false)}
                aria-label="Close announcement"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 6L6 18M6 6l12 12"/>
                </svg>
            </button>
        </div>
    );
}
